const ITEMS = [
    "Hipoteca 100%",
    "Estudio gratuito",
    "Sin vinculaciones",
    "Asesor personal",
    "100% online",
    "Hipoteca joven",
    "Respuesta en 24h",
    "Gestión integral",
];

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="editorial-marquee"
            className="bg-[#1F3B5B] border-y border-white/10 py-5 overflow-hidden select-none"
            aria-hidden="true"
        >
            <div className="flex w-max animate-marquee items-center">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center">
                        <span className="font-mono text-sm sm:text-base uppercase tracking-[0.25em] text-white/70 px-8">
                            {item}
                        </span>
                        <span className="text-emerald-400 text-lg">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
}
